import React from 'react';
import NavigationMenuSection from "../../../menu-items/section/section";
import NavigationMenuItemUrl from "../../../menu-items/menu-item-url";
import NavigationSection from "../../../../../core/model2/navigation/navigation-section";
import NavigationMenuItemSectionLink from "../../../menu-items/menu-item-section-link";
import NavigationMenuItemFoldable from "../../../menu-items/menu-item-foldable";

type Props = {
    onToggle      : (a: string, b: boolean)=>void
    isManager?    : boolean
    collapseState : any
    navigationSection   : NavigationSection
}

export default function MenuSettingsAccount(props: Props) {

    const onToggle = (isOpen: boolean) => {
        props.onToggle('my-account', isOpen)
    };

    return (
        <NavigationMenuSection name="Account settings" collapsible={true} onToggle={onToggle} isOpen={!props.collapseState.isCollapsed('my-account')}>

            <NavigationMenuItemUrl name="My Account" icon="i5-user" url="my-account" exactUrl={true} navigationSection={props.navigationSection} />
            <NavigationMenuItemUrl name="Skin & Layout" icon="ui5-ico-theme" url="settings/skin" navigationSection={props.navigationSection}/>

            <NavigationMenuItemFoldable name="Navigation" icon="i5-panel">
                <NavigationMenuItemUrl className="sub-item level-1" name="Navigation Panel" icon="i5-panel" url="settings/navigation-panel" navigationSection={props.navigationSection}/>
                <NavigationMenuItemUrl className="sub-item level-1" name="Project Navigation" icon="i5-navigation-light" url="settings/project-navigation" navigationSection={props.navigationSection}/>
            </NavigationMenuItemFoldable>


            <NavigationMenuItemSectionLink name="Switch organization" icon="i5-open-new-window" url="select-organization" navigationSection={props.navigationSection}/>


        </NavigationMenuSection>
    )

}
